var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",on:{"click":function($event){return _vm.showQR()}}},[_c('div',{staticClass:"qr__block"},[_c('qrcode-vue',{staticClass:"qr",attrs:{"value":_vm.qrValue,"size":_vm.size}}),_c('h3',{staticClass:"mt-3"},[_vm._v("Просканируйте QR-код через приложение Egov-mobile")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }